<template>
  <div>
    <div>
      <v-card
          class="mx-auto my-5"
          max-width="700"
      >
        <v-toolbar flat>
          <v-text-field v-model="keywords" label="Alias Name" clearable @input="querySearch"></v-text-field>
        </v-toolbar>
      </v-card>
    </div>

    <div v-show="show">
      <v-container>
        <v-row class="pa-3" justify="start">
          <v-col md="1" v-for="(hero,index) in searchList" :key="index">
            <div :style="{'width':`${height}px`}" @click="info(hero,hero.positions[0])">
              <v-img :src="hero.img" :height="height" :width="height"
                     :class="$vuetify.breakpoint.name === 'xs' ? 'rounded-circle' : '' "/>
              <div class="pa-2 text-center text-caption text-lg-body-1">
                {{ hero.label }}
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <div v-show="!show" class="mt-3">

      <v-card class="ma-3">
        <v-card-title>
          <v-tabs v-model="tab">
            <v-tab v-for="(item,index) in positionList" :key="index">
              {{ item.label }}
            </v-tab>
          </v-tabs>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-tabs-items v-model="tab" class="mt-3">
            <v-tab-item
                v-for="(item,index) in positionList"
                :key="index"
            >
              <div>
                <v-container fluid>
                  <v-row justify="start">
                    <v-col cols="3" md="2" sm="2" xl="1" lg="1" v-for="(hero,index) in item.heroList" :key="index">
                      <div :style="{'width':`${height}px`}" @click="info(hero,item)">
                        <v-img :src="hero.img" :height="height" :width="height"
                               :class="$vuetify.breakpoint.name === 'xs' ? 'rounded-circle' : '' "/>
                        <div class="ma-2 text-center text-caption text-lg-body-1">
                          {{ hero.label }}
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-container>
              </div>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>

      </v-card>
    </div>

    <rank :position-list="positionList" :tab="tab"></rank>

    <v-dialog
        v-model="infoDialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
    >
      <v-card v-if="infoDialog">
        <v-toolbar>
          <v-toolbar-title>{{ heroInfo.summary.name }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="infoDialog = false">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-toolbar>
        <champions :heroInfo="heroInfo" :position="position"></champions>
      </v-card>
    </v-dialog>


  </div>
</template>

<script>
import {mapMutations} from "vuex";
import {statistics, support} from '@/api/resources/game'

import Rank from "@/components/game/Rank"
import Champions from "@/components/game/Champions"

export default {
  data: () => ({
    // matchUp: undefined,
    // window: undefined,
    position: undefined,
    infoDialog: false,
    show: false,
    keywords: undefined,
    tab: undefined,
    heroList: [],
    positionList: [],
    // activeList: [
    //   {
    //     name: 'TOP',
    //     label: '上单'
    //   },
    //   {
    //     name: 'JUNGLE',
    //     label: '打野'
    //   },
    //   {
    //     name: 'MID',
    //     label: '中单'
    //   },
    //   {
    //     name: 'ADC',
    //     label: '下路'
    //   },
    //   {
    //     name: 'SUPPORT',
    //     label: '辅助'
    //   }
    // ],
    searchList: [],
    heroInfo: {}
  }),
  components: {
    Rank,
    'champions': Champions
  },
  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    height() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return 60
        case 'sm':
          return 50
        case 'md':
          return 70
        case 'lg':
          return 90
        case 'xl':
          return 90
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    ...mapMutations(['setLoading', 'clearLoading']),
    init() {
      this.setLoading()
      statistics().then(req => {
        let {heroList, positionList} = req.data.data;
        this.positionList = positionList
        this.heroList = heroList
      }).finally(() => {
        this.clearLoading()
      })
    },
    info(hero, {name}) {
      this.heroInfo = {}
      this.position = name;
      this.setLoading();

      let {key, heroId} = hero

      support({key: key, position: name, heroId: heroId}).then(req => {
        let {...heroInfo} = req.data.data
        this.heroInfo = heroInfo
        this.infoDialog = true
      }).catch(() => {
        this.infoDialog = false
      }).finally(() => {
        this.clearLoading();
      })
    },
    querySearch() {
      if (!this.keywords) {
        this.searchList = [];
        this.show = false
        return;
      }
      this.show = true
      const result = [...this.heroList];
      this.searchList = result.filter(this.createFilter(this.keywords));
    },
    createFilter(queryString) {
      return restaurant => {
        return restaurant.keywords.find(item => {
          return item.replace(/(^\s*)|(\s*$)/g, "").toLowerCase().indexOf(queryString.replace(/(^\s*)|(\s*$)/g, "").toLowerCase()) !== -1;
        });
      };
    },
  }
}
</script>

<style scoped>
</style>
